import { SitesInitialization } from './SitesInitialization'
import ModalPopup from '../../components/ModalPopup/ModalPopup';
import { ButtonStyles, ModalPopupSize } from '../../lib/enums';
import Table from '../../components/Table/Table';
import ValidationMessage from '../../components/ValidationMessage/ValidationMessage';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

const Sites = () => {
    const {
        projectId,
        projectName,
        sitesData,
        handleAddSite,
        handleDeleteSiteRow,
        handleModalConfirmSiteDeletion,
        handleModalCancelSiteDeletion,
        handleDuplicateSiteRow,
        sitesTableColumns,
        showModal,
        maxNameLength,
        hasNameError,
        handleValidationMessageCloseEvent
    } = SitesInitialization()
    
    return (
        <div className="container msds-block-padding-small">
            <div className="row">
                <div className="col-12">
                    <Breadcrumb projectId={projectId} projectName={projectName} />
                </div>
                <h1 className="msds-text-header-1">{projectName}</h1>
                {hasNameError && (
                    <div className="col-12">
                        <ValidationMessage
                            message={'Unable to post site as the name must be under ' + maxNameLength + ' characters.'}
                            handleCloseEvent={handleValidationMessageCloseEvent}
                        />
                    </div>
                )}
                {sitesData && (
                    <div className="row">
                        <Table
                            data={sitesData}
                            columns={sitesTableColumns}
                            addButtonLabel="Add New Site"
                            addButtonLabelIcon="plus"
                            onAddButtonClick={handleAddSite}
                            handleDeleteDataRow={handleDeleteSiteRow}
                            handleDuplicateRow={handleDuplicateSiteRow}
                            customCssClasses='msds-table--sites'
                        />
                        <ModalPopup
                            headline="Confirm Delete"
                            description="Are you sure you want to delete this row?"
                            size={ModalPopupSize.Small}
                            showModal={showModal}
                            onCloseButtonclick={handleModalCancelSiteDeletion}
                            button1Style={ButtonStyles.Danger}
                            button1Label="Yes, delete"
                            button1OnClickHandler={handleModalConfirmSiteDeletion}
                            button2Style={ButtonStyles.Tertiary}
                            button2Label="Cancel"
                            button2OnClickHandler={handleModalCancelSiteDeletion}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Sites;
